import { Rocket, Sparkles, Loader2, CheckCircle2 } from 'lucide-react';
import { useEffect, useState } from 'react';

interface WizardPublishingProps {
  spaceName: string;
}

export function WizardPublishing({ spaceName }: WizardPublishingProps) {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setStep((s) => (s < 3 ? s + 1 : s));
    }, 400);
    return () => clearInterval(timer);
  }, []);

  const steps = [
    "Finalisation des paramètres...",
    "Optimisation de l'affichage...",
    "Synchronisation des données...",
    "Publication en cours !",
  ];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '600px',
        background: 'white',
        borderRadius: '24px',
        padding: '4rem 2rem',
        textAlign: 'center',
        boxShadow: '0 10px 40px rgba(0,48,60,0.06)',
        border: '1px solid #f0f0f0',
      }}
    >
      <div style={{ position: 'relative', marginBottom: '3rem' }}>
        <div
          style={{
            width: '120px',
            height: '120px',
            borderRadius: '50%',
            background: 'rgba(0,117,141,0.05)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            animation: 'pulse 2s infinite',
          }}
        >
          {step < 3 ? (
            <Rocket
              size={56}
              color="#00758d"
              style={{
                animation: 'launch 1s infinite alternate cubic-bezier(0.45, 0.05, 0.55, 0.95)',
              }}
            />
          ) : (
            <CheckCircle2 size={56} color="#00758d" className="animate-bounce" />
          )}
        </div>
        
        <Sparkles
          style={{
            position: 'absolute',
            top: '-10px',
            right: '-10px',
            color: '#dfc32f',
            animation: 'spin 3s linear infinite',
          }}
          size={32}
        />
        
        <div
          style={{
            position: 'absolute',
            bottom: '-5px',
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        >
          <Loader2 size={24} color="#00758d" className="animate-spin" />
        </div>
      </div>

      <h2
        style={{
          fontSize: '1.75rem',
          fontWeight: 800,
          color: '#00303c',
          marginBottom: '1rem',
        }}
      >
        Publication de {spaceName}
      </h2>

      <div style={{ height: '24px', marginBottom: '2rem' }}>
        <p
          key={step}
          style={{
            fontSize: '1.1rem',
            color: '#00758d',
            fontWeight: 600,
            animation: 'slideUp 0.3s ease-out',
          }}
        >
          {steps[step]}
        </p>
      </div>

      <div
        style={{
          width: '300px',
          height: '6px',
          background: '#f1f5f9',
          borderRadius: '3px',
          overflow: 'hidden',
          margin: '0 auto',
        }}
      >
        <div
          style={{
            height: '100%',
            background: 'linear-gradient(90deg, #00758d 0%, #00303c 100%)',
            width: `${((step + 1) / steps.length) * 100}%`,
            transition: 'width 0.4s ease-out',
            borderRadius: '3px',
          }}
        />
      </div>

      <style>
        {`
          @keyframes launch {
            from { transform: translateY(0) rotate(-45deg); }
            to { transform: translateY(-15px) rotate(-45deg); }
          }
          @keyframes pulse {
            0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(0, 117, 141, 0.2); }
            70% { transform: scale(1.05); box-shadow: 0 0 0 15px rgba(0, 117, 141, 0); }
            100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(0, 117, 141, 0); }
          }
          @keyframes slideUp {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}
